import React, { useState } from "react"
import ShareButton from "./ShareButton"
import InstagramIcon from "../../../resource/icon/instagram.svg"
import DownloadIcon from "../../../resource/icon/download.svg"
import ShareDoneIcon from "../../../resource/icon/share-done.svg"
import { Upload } from "../../.."
import { isTouchDevice } from "../../../library/device/DeviceUtil"
import * as ShareUtil from "../../../library/sharing/ShareUtil"
import Spinner from "../../Spinner/Spinner"
import stylesheet from "./ShareButton.module.scss"
import { useTranslation } from "react-i18next"

interface DownloadButtonProps {
  instagram?: boolean
  upload: Upload
  order: number
  trackClick: () => void
  handleEmail: () => void
  handleTapAndHoldToSave: () => void
}

export default function DownloadButton({ instagram, order, upload, trackClick, handleEmail, handleTapAndHoldToSave }: DownloadButtonProps) {
  const [downloaded, setDownloaded] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const { t } = useTranslation()

  const isDesktop = !isTouchDevice()

  const resolveMediaFile = () => {
    if (upload.isVideo()) {
      return {
        url: upload.media.video,
        extension: "mp4"
      }
    } else if (upload.isGif() && instagram) {
      return {
        url: upload.media.instagramVideo,
        extension: "mp4"
      }
    } else {
      return {
        url: upload.media.original,
        extension: upload.isGif() ? "gif" : "jpg"
      }
    }
  }

  const savePhoto = () => {
    trackClick()

    if (isDesktop) {
      // On desktop they can download the file directly
      setLoading(true)

      const mediaFile = resolveMediaFile()
      ShareUtil.fetchBlob(
        mediaFile.url,
        (blob) => {
          let filename = upload.isVideo() ? t("shareSheet.filenames.video") : t("shareSheet.filenames.photo")
          if (instagram) filename = t("shareSheet.filenames.instagram")
          ShareUtil.saveFile(blob, filename, mediaFile.extension)
          setLoading(false)
          setDownloaded(true)
        },
        () => {
          handleEmail()
          setLoading(false)
        }
      )
    } else if (upload.isVideo() || (upload.isGif() && instagram)) {
      // iPhones at least can't tap and hold to save videos
      handleEmail()
    } else {
      handleTapAndHoldToSave()
    }
  }

  let commonProps = {
    order: order,
    onClick: savePhoto
  }

  if (instagram) {
    return (
      <ShareButton
        {...commonProps}
        style={{ background: "linear-gradient(12deg, rgba(254,180,82,1) 0%, rgba(233,34,80,1) 33%, rgba(195,39,149,1) 66%, rgba(126,58,196,1) 100%)" }}
      >
        <img src={downloaded ? ShareDoneIcon : InstagramIcon} />
        {t("shareSheet.buttons.instagram")}
      </ShareButton>
    )
  }

  return (
    <ShareButton
      {...commonProps}
      style={{ backgroundColor: "#474848" }}
    >
      {loading ?
        <Spinner className={stylesheet.spinner} thickness="3px" color="#fff" />
        :
        <img src={downloaded ? ShareDoneIcon : DownloadIcon} />
      }
      {t("shareSheet.buttons.download")}
    </ShareButton>
  )
}
